import { render, staticRenderFns } from "./EditCitationModal.vue?vue&type=template&id=0215def8"
import script from "./EditCitationModal.vue?vue&type=script&lang=js"
export * from "./EditCitationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports